import React from "react";
import TimeAgo from "react-timeago";

const RoomSearchList = ({ items = [], onView, className }) => {
    if (items.length < 1)
        return (
            <div className="text-center text-pink">
                <i className="material-icons" style={{ fontSize: "4em" }}>
                    info
                </i>
                <br />
                <strong>No Room search has been added yet</strong>
            </div>
        );
    return (
        <div className={`${className}`}>
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>Justification for search</th>
                        <th>Damage Report</th>
                        <th>Search Time</th>
                        <th>Date Created</th>
                        <th className="text-center">view</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={index}>
                            <td className="inbox-small-cells">
                                <div className="todo-check pull-left">{index + 1}</div>
                            </td>
                            <td className="view-message">
                                <span>{item.reason}</span>
                                <br />
                                <small className="text-muted">
                                    <TimeAgo date={item.created_at}></TimeAgo>
                                </small>
                            </td>
                            <td className="view-message">
                                <small>
                                    <strong>Prior to search:</strong>
                                </small>
                                <br />
                                <span>{item.priorToSearch} </span> <br />
                                <small>
                                    <strong>Post search:</strong>
                                </small>
                                <br />
                                <span> {item.postToSearch}</span>
                            </td>
                            <td className="view-message">
                                <strong>Start Time: </strong> <br />
                                <span>{item.startTime} </span> <br />
                                <strong>End Time: </strong> <br />
                                <span> {item.endTime}</span>
                            </td>
                            <td className="view-message">
                                {Intl.DateTimeFormat("en-GB", {
                                    month: "short",
                                    year: "numeric",
                                    weekday: "short",
                                    day: "numeric"
                                }).format(new Date(item.created_at))}
                            </td>

                            <td className="view-message text-center">
                                <button onClick={() => onView(item)} title="View Detail" className="mdl-button mdl-button--icon mdl-button--colored btn-default">
                                    <i className="material-icons text-primary">trending_flat</i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default RoomSearchList;
